// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__joA1z","submit":"button_submit__1S3ql"};